import Checkbox from '@monofront/design-system/components/Form/Checkbox';
import Label from '@monofront/design-system/components/Form/Label';
import AddressesListAndForm from '../components/AddressesListAndForm';
import { useTranslations } from 'next-intl';
import { useCheckoutSelectAddressMachine } from '@context/checkoutCartMachineContext';
import { SELECT_ADDRESS_TRANSITIONS } from '@monofront/business/stateMachines';

const CheckoutBillingAddress = () => {
  const { selectAddressState, sendToSelectAddress } =
    useCheckoutSelectAddressMachine();
  const tCheckout = useTranslations('Checkout');
  const { isBillingAndShippingEqual } = selectAddressState.context;

  return (
    <>
      <div className="checkbox-with-label">
        <Checkbox
          name={tCheckout('useSameAddress')}
          required={false}
          id="same-as-shipping-address"
          onChange={() => {
            sendToSelectAddress(
              SELECT_ADDRESS_TRANSITIONS.SELECT_BILLING_EQUAL_SHIPPING_ADDRESS,
            );
          }}
          checked={isBillingAndShippingEqual}
          dataTestId={`CheckoutBillingAddress-Checkbox-${tCheckout(
            'useSameAddress',
          )}`}
        />
        <Label id="same-as-shipping-address">
          {tCheckout('sameAsBillingAddress')}
        </Label>
      </div>
      {isBillingAndShippingEqual ? null : (
        <AddressesListAndForm
          selectIdPrefix="billing-address"
          isForBillingAddress
        />
      )}
      <style jsx>{`
        .checkbox-with-label {
          margin: var(--space-4) 0 var(--space-5) var(--space-3);
        }

        .checkbox-with-label {
          display: flex;
          align-items: center;
        }

        .checkbox-with-label :global(label) {
          margin-left: var(--space-4);
        }
      `}</style>
    </>
  );
};

export default CheckoutBillingAddress;
